import React, { useEffect, useState } from 'react'
import {
    Modal, Checkbox, Button, Text, Flex, Box, tokens,
} from 'src/componentv2'
import {
    NIN_ENFORCEMENT_MODAL_TITLE,
    NIN_ENFORCEMENT_CONFIRMATION_LABEL,
} from 'src/utils/onboardingPolicyCopy'

export interface NinEnforcementModalProps {
    open: boolean
    onClose: () => void
    onConfirm: () => void
}

// Enabling NIN only works end-to-end if BVN submission isn't also being forced on BankOne
// CBA, so this makes the institution admin explicitly acknowledge that before NIN turns on.
// Declining (or dismissing) leaves NIN unchecked.
export const NinEnforcementModal: React.FC<NinEnforcementModalProps> = ({ open, onClose, onConfirm }) => {
    const [acknowledged, setAcknowledged] = useState(false)

    useEffect(() => {
        if (open) setAcknowledged(false)
    }, [open])

    return (
        <Modal open={open} onClose={onClose} title={NIN_ENFORCEMENT_MODAL_TITLE} maxWidth="46rem">
            <Text fontSize="1.4" color={tokens.textMuted}>
                You are about to enable <strong>NIN</strong> as an identification option for customer onboarding.
            </Text>
            <Text fontSize="1.4" color={tokens.textMuted} topMargin="1.2">
                Before proceeding, please ensure that{' '}
                <strong>Enforce BVN Submission When Creating New Customer is disabled on BankOne CBA</strong>.
                If BVN is still enforced, customers attempting to open an account using NIN may be unable to
                complete the onboarding process.
            </Text>
            <Text fontSize="1.4" color={tokens.textMuted} topMargin="1.2">
                Please confirm that you have reviewed your BankOne CBA configuration before enabling NIN.
            </Text>
            <Box topMargin="1.6">
                <Checkbox
                    id="nin-bvn-enforcement-ack"
                    checked={acknowledged}
                    onChange={setAcknowledged}
                    label={NIN_ENFORCEMENT_CONFIRMATION_LABEL}
                />
            </Box>
            <Flex justify="flex-end" gap="1.2" topMargin="2.4">
                <Button variant="outline" onClick={onClose}>Cancel</Button>
                <Button variant="primary" onClick={onConfirm} disabled={!acknowledged}>Enable NIN</Button>
            </Flex>
        </Modal>
    )
}

export default NinEnforcementModal
